// services/guestName.service.ts
import { ref } from 'vue'

const STORAGE_KEY = 'guestName'

const guestName = ref(localStorage.getItem(STORAGE_KEY) || '')

export const guestNameService = {
    
    set(name) {
        guestName.value = name
        localStorage.setItem(STORAGE_KEY, name)
    },
    
    clear() {
        guestName.value = ''
        localStorage.removeItem(STORAGE_KEY)
    },
    
    fromUrl() {
        const params = new URLSearchParams(window.location.search)
        const name = params.get('guestName')
        return name ? decodeURIComponent(name) : null
    },
    
    init() {
        const urlName = this.fromUrl()
        if (urlName) {
            this.set(urlName)
        }
    },
    guestName,
}
